import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { Info } from 'shared/components/Info';
import { convertUsdToCrypto, formatCrypto } from 'shared/utils';
import { walletSelector } from 'modules/payments/store/wallet/selectors';
import { useStyles } from './ExchangeRate.style';
import { PopperPlacementType } from '@mui/material';

type Variant = 'short' | 'wide';

interface ExchangeRateProps {
  variant?: Variant;
  placement?: PopperPlacementType;
}

export const ExchangeRate: FC<ExchangeRateProps> = ({ variant = 'wide', placement }) => {
  const { classes } = useStyles();
  const exchangeRate = useSelector(walletSelector.exchangeRate);
  const estimatedPrice = formatCrypto(convertUsdToCrypto(1, exchangeRate));
  const infoPlacement = placement ?? (variant === 'wide' ? 'right' : 'bottom');

  return (
    <Info
      placement={infoPlacement}
      sx={{ zIndex: 10000 }}
      width={200}
      control={
        <Typography variant="subtitle2" className={classes.text}>
          {variant === 'wide' && 'Estimate price: '}$1 ≈ {estimatedPrice}
        </Typography>
      }
    >
      <Typography variant="subtitle2">
        The price of crypto changes frequently based on market conditions.
      </Typography>
    </Info>
  );
};
